import { observer } from 'mobx-react-lite'
import { FC, useEffect, useState } from 'react'
import { IStudioStore } from '../../../stores/StudioStore'
import { AlternativePlaybackControls } from '../common/PlaybackControls'

interface SongPlaybackControlsProps {
  player: IStudioStore
}

const SongPlaybackControls: FC<SongPlaybackControlsProps> = ({ player }) => {
  const [repeatSong, setRepeatSong] = useState(false)
  const { play, pause, isPlaying, stop, playhead, song, userSetPlayhead } = player
  const handlePlayPause = () => (isPlaying ? pause() : play())
  const handleRepeat = () => setRepeatSong(!repeatSong)
  const handleStop = () => stop()
  useEffect(() => {
    if (playhead >= song.songMintLength16Notes) {
      if (repeatSong) userSetPlayhead(0)
      else stop()
    }
  }, [playhead])
  return (
    <AlternativePlaybackControls
      isPlaying={isPlaying}
      isRepeat={repeatSong}
      onPlayPause={handlePlayPause}
      onRepeat={handleRepeat}
      onStop={handleStop}
    />
  )
}

export default observer(SongPlaybackControls)
